/**
 * Rendered by main.tsx in place of the app when a production-style bundle was
 * built from a missing or wrong env. Loud on purpose: the previous failure mode
 * was a working-looking portal whose every request went to localhost:3000.
 */
export function ConfigError({ problems }: { problems: readonly string[] }) {
  return (
    <main role="alert" className="min-h-screen bg-neutral-950 px-6 py-16 text-neutral-100">
      <div className="mx-auto max-w-2xl space-y-6">
        <p className="text-xs font-semibold uppercase tracking-wide text-red-400">Deployment misconfigured</p>
        <h1 className="text-2xl font-semibold">This LienGuardian build cannot run</h1>
        <p className="text-neutral-300">
          The dashboard was published without a valid production environment, so it has not contacted any API.
          Rebuild it with the values in <code>ops/dashboard.env.empire</code> and publish again.
        </p>
        <ul className="list-disc space-y-2 pl-6 text-sm text-neutral-200">
          {problems.map((problem) => (
            <li key={problem}>{problem}</li>
          ))}
        </ul>
      </div>
    </main>
  );
}
